import React, {useState} from "react";
import {Modal} from "@material-ui/core";
import LanguageIcon from "@material-ui/icons/Language";
import CloseIcon from "@material-ui/icons/Close";
import {useTranslation} from "react-i18next";

const TranslationModal = props => {
    const {t} = useTranslation();

    const {translations, onChange} = props;
    const [modalOpen, setModalOpen] = useState(false);

    const changeValue = (language_id, defaultValue, value) => {
        if (value && value !== defaultValue) {
            onChange({language_id, value});
        }
    };

    return (
        <>
            <button className="btn btn-icon btn-ligh ml-2 edit_button" onClick={() => setModalOpen(true)}>
                <LanguageIcon />
            </button>
            <Modal open={modalOpen}>
                <div className="vh-100 vw-100 d-flex justify-content-center align-items-center">
                    <div className="card card-custom" style={{minWidth: 500}}>
                        <div className="card-header d-flex justify-content-between">
                            <div className="card-title">{t("GENERAL.DEFINE_TRANSLATION")}</div>
                            <button className="btn btn-link p-0" onClick={() => setModalOpen(false)}>
                                <CloseIcon />
                            </button>
                        </div>
                        <div className="card-body">
                            {translations.map((translation, i) => (
                                <div key={i} className="row">
                                    <div className="col-4 mt-3">
                                        <label className="form-label">{translation.language.name}</label>
                                    </div>
                                    <div className="col-8">
                                        <input
                                            type="text"
                                            className={`form-control form-control-solid h-auto py-2 px-4 text-dark-75 font-size-base w-100`}
                                            defaultValue={translation.value}
                                            onKeyDown={e => {
                                                const value = e.target.value.replace(/\s\s+/g, " ");

                                                if (e.key === "Enter") {
                                                    const trimmed = value.trim();
                                                    if (trimmed) {
                                                        trimmed !== translation.value &&
                                                            changeValue(
                                                                translation.language_id,
                                                                translation.value,
                                                                trimmed
                                                            );
                                                    }
                                                    e.target.value = translation.value;
                                                } else e.target.value = value;
                                            }}
                                            onBlur={e => {
                                                const name = e.target.value.trim();
                                                if (name) {
                                                    name !== translation.value &&
                                                        changeValue(translation.language_id, translation.value, name);
                                                }
                                                e.target.value = translation.value;
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default TranslationModal;
